import {request} from '@/utils/request'

// 修改密码
export function postSettingPassword(data) {
  return request('POST', '/user/password/change', data, true)
}
// 操作日志
export function getLog(data) {
  return request('GET', '/access-log/page', data, true)
}
